export default __webpack_public_path__ + "static/media/image70.67e3fa12.svg";